// Data pro Májofest Otrokovice

export const festivalInfo = {
  name: "MÁJOFEST OTROKOVICE",
  subtitle: "PIVNÍ FESTIVAL S REGIONÁLNÍMI KAPELAMI",
  date: "2. května 2026",
  time: "15:00–23:30",
  location: "Otrokovice",
  expectedVisitors: "1 300",
  entrance: "VSTUP ZDARMA",
  eventId: "majofest-otrokovice-2026",
  edition: "2. ročník pivního festivalu",
};

export const programSchedule = {
  friday: {
    day: "Pátek 2. 5. 2026",
    time: "15:00–23:30",
    description: "Pivní speciály, grilované speciality a živá hudba",
  },
};

export const programHighlights = [
  "🍺 15:00 - Naražení pivních speciálů",
  "🎸 FOCUS ROCK - legendární zlínská zábavová kapela",
  "🎤 2 regionální kapely",
  "🍻 20 druhů piv na čepu",
  "🍺 Pivní speciály",
  "🍖 Grilované speciality",
  "🎪 Párty atmosféra",
  "🌙 23:30 - konec akce",
];

export const whyJoinReasons = [
  {
    title: "Pivní festival",
    description: "2. ročník pivního festivalu s 20 druhy piv na čepu, včetně pivních speciálů. Ideální pro prodejce grilovaných specialit a pochutin k pivu.",
    icon: "Beer",
  },
  {
    title: "Večerní atmosféra",
    description: "Akce probíhá od 15:00 do 23:30. Dlouhá otevírací doba zajišťuje stabilní prodej od odpoledne až do večera.",
    icon: "Clock",
  },
  {
    title: "Regionální kapely",
    description: "FOCUS ROCK a další regionální kapely přitahují věrné publikum. Živá hudba vytváří skvělou atmosféru pro prodej.",
    icon: "Music",
  },
  {
    title: "Vstup zdarma",
    description: "Festival s volným vstupem přitahuje široké publikum. Žádná vstupní bariéra = více návštěvníků = vyšší tržby.",
    icon: "Ticket",
  },
  {
    title: "1 300 návštěvníků",
    description: "Očekávaná návštěvnost 1 300 osob. Pivní festival s dlouhou otevírací dobou zajišťuje vysokou spotřebu jídla.",
    icon: "Users",
  },
  {
    title: "Omezený počet prodejců",
    description: "Počet prodejních míst je omezen, aby měl každý prodejce dostatečný prodejní potenciál.",
    icon: "CheckCircle2",
  },
];

export const vendorCategories = {
  priority: {
    title: "PRIORITA: Speciality z grilu a food trucky",
    description: "Hledáme prodejce s grilovanými specialitami a rychlým občerstvením k pivu.",
    requirements: [
      "Grilované maso a speciality",
      "Food trucky s rychlým občerstvením",
      "Pochutiny vhodné k pivu",
      "Zkušenosti z pivních festivalů",
    ],
  },
  additional: {
    title: "Doplňkový prodej",
    description: "Omezený počet míst pro doplňkový sortiment",
    categories: [
      "Sladké speciality a dezerty",
      "Pochutiny k pivu (topinky, klobásy, atd.)",
      "Hračky pro děti",
      "Drobný sortiment",
    ],
  },
};

export const importantRules = [
  {
    title: "Zákaz prodeje nápojů",
    description: "Alkoholické i nealkoholické nápoje (včetně piva) zajišťuje výhradně pořadatel.",
    note: "Výjimky pouze po předchozí domluvě s pořadatelem.",
    icon: "XCircle",
  },
  {
    title: "Ceny bez DPH",
    description: "Všechny uvedené ceny jsou bez DPH. DPH bude připočítáno podle platné legislativy.",
    icon: "CreditCard",
  },
];

export const pricingConditions = {
  grill: {
    title: "SPECIALITY Z GRILU / FOOD TRUCKY",
    size: "max 6x3m",
    category: "grilované speciality",
    price: "5.000 Kč",
  },
  additional: {
    title: "DOPLŇKOVÝ SORTIMENT",
    size: "max 3x3m",
    category: "sladké, hračky, pochutiny k pivu",
    price: "3.000 Kč",
  },
  electricity: {
    title: "ENERGIE - příkon (MAX 12 KW)",
    options: [
      { range: "DO 3KW", price: "1.750 Kč" },
      { range: "3KW až 6KW", price: "3.300 Kč" },
      { range: "nad 6KW", price: "4.500 Kč" },
    ],
    note: "(celá akce)",
  },
  note: "Ceny jsou uvedeny bez DPH",
};

export const contactInfo = {
  name: "Jakub Vodárek",
  phone: "+420 774 750 456",
  email: "info@vseproakci.cz",
};

export const heroImage = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/b8q85k2n_Sni%CC%81mek%20obrazovky%202026-03-11%20v%C2%A021.29.47.png";
